module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.4-config-component.1bbf22b5.png";